import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, RolesEnum } from '@irembo-andela/irembogov3-common';
import { MainNavigationBarLinkItems } from '../../core/config/nav-bar-link-items.config';
import { RolesGuard } from '../../core/guards/roles.guard';
import { ConfigureServiceChangeRequestComponent } from './configure-service-change-request/configure-service-change-request.component';
import { ManageServiceChangeRequestsComponent } from './manage-service-change-requests/manage-service-change-requests.component';
import { ReviewServiceChangeRequestComponent } from './review-service-change-request/review-service-change-request.component';
import { ViewServiceChangeRequestComponent } from './view-service-change-request/view-service-change-request.component';
import { ServiceTemplatesComponent } from './service-templates/service-templates.component';
import { TemplatePreviewComponent } from './service-templates/template-preview/template-preview.component';
import { CreateTemplateComponent } from './service-templates/create-template/create-template.component';
import { EditTemplateComponent } from './service-templates/edit-template/edit-template.component';
import { ConvertExistingServiceComponent } from './service-templates/convert-existing-service/convert-existing-service.component';

const routes: Routes = [
  {
    path: '',
    component: ManageServiceChangeRequestsComponent,
    data: {
      roles: MainNavigationBarLinkItems['services'].allowedRoles,
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'templates',
    component: ServiceTemplatesComponent,
    data: {
      roles: [RolesEnum.ROLE_IREMBOGOV_ADMIN, RolesEnum.ROLE_SERVICE_MANAGER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'templates/create',
    component: CreateTemplateComponent,
    data: {
      roles: [RolesEnum.ROLE_IREMBOGOV_ADMIN],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'templates/convert-existing',
    component: ConvertExistingServiceComponent,
    data: {
      roles: [RolesEnum.ROLE_IREMBOGOV_ADMIN],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'templates/:id/edit',
    component: EditTemplateComponent,
    data: {
      roles: [RolesEnum.ROLE_IREMBOGOV_ADMIN],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'templates/:id/preview',
    component: TemplatePreviewComponent,
    data: {
      roles: [RolesEnum.ROLE_IREMBOGOV_ADMIN, RolesEnum.ROLE_SERVICE_MANAGER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  // {
  //   path: 'templates/:id/use',
  //   redirectTo: 'configure/new',
  //   data: {
  //     roles: [RolesEnum.ROLE_SERVICE_MANAGER],
  //   },
  //   canActivate: [AuthGuard, RolesGuard],
  // },
  {
    path: 'configure/:requestId',
    component: ConfigureServiceChangeRequestComponent,
    data: {
      roles: [RolesEnum.ROLE_SERVICE_MANAGER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'review/:requestId',
    component: ReviewServiceChangeRequestComponent,
    data: {
      roles: [RolesEnum.ROLE_QA_REVIEWER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'view/:requestId',
    component: ViewServiceChangeRequestComponent,
    data: {
      roles: [RolesEnum.ROLE_SERVICE_MANAGER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  {
    path: 'configure/:requestId/certificate',
    loadChildren: () =>
      import('../designer/designer.module').then(m => m.DesignerModule),
    data: {
      roles: [RolesEnum.ROLE_SERVICE_MANAGER],
    },
    canActivate: [AuthGuard, RolesGuard],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServicesRoutingModule {}
